export const SET_PROGRESS = "SET_PROGRESS";
export const LOAD_COUNTRIES = "LOAD_COUNTRIES";
export const LOAD_CITIZENSHIP = "LOAD_CITIZENSHIP";
export const SET_FIELD = "SET_FIELD";
export const SET_CONFIG = "SET_CONFIG";
export const SET_HAS_ERROR = "SET_HAS_ERROR";
export const SET_STEP = "SET_STEP";
export const SET_ERRORS = "SET_ERRORS";
export const SET_VALID_FIELD = "SET_VALID_FIELD";
export const DELETE_ERROR = "DELETE_ERROR";
export const CHOOSE_TAX_OFFICE = "CHOOSE_TAX_OFFICE";
export const SET_FORM_DATA = "SET_FORM_DATA";
export const SET_LOCK = "SET_LOCK";
export const ADD_ERRORS = "ADD_ERRORS";
export const SET_SELECT_STATE = "SET_SELECT_STATE";
export const SET_DARK_BACKGROUND = "SET_DARK_BACKGROUND";
export const DETERMINE_STEP = "DETERMINE_STEP";
export const SET_GLOBAL_ERROR = "SET_GLOBAL_ERROR";
export const SET_RESPONSE = "SET_RESPONSE";
export const LOAD_TMSC = "LOAD_TMSC";
export const LOAD_QUERY = "LOAD_QUERY";
export const SET_ROUTE = "SET_ROUTE";
